import { useMemo } from 'preact/hooks';
import { useFilter } from '../../contexts/FilterContext';
import { PERIOD_MODE_OPTIONS, periodModeLabel, type PeriodMode } from '../../functions/calculations';
import { HeaderFilterSelect, type HeaderFilterOption } from './HeaderFilterSelect';

export const PeriodFilter = () => {
  const { periodMode, setPeriodMode } = useFilter();

  const options = useMemo<HeaderFilterOption<PeriodMode>[]>(
    () =>
      PERIOD_MODE_OPTIONS.map((option) => ({
        key: option.id,
        label: option.label,
        value: option.id,
      })),
    [],
  );

  return (
    <HeaderFilterSelect
      ariaLabel="Period"
      valueLabel={periodModeLabel(periodMode)}
      options={options}
      selectedKey={periodMode}
      onSelect={setPeriodMode}
    />
  );
};
